import { useEffect } from 'react';
import Cookies from 'js-cookie';
export default function SSOCallback() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const ssoIdToken = params.get('ssoIdToken');
    const ssoChallengeSession = params.get('ssoChallengeSession');
    const ssoChallengeDevice = params.get('ssoChallengeDevice');
    const ssoUsername = params.get('ssoUsername');
    const authSource = params.get('authSource');
    if (ssoIdToken) {
      try {
        localStorage.setItem('idToken', ssoIdToken);
        const attrs = JSON.parse(atob(ssoIdToken.split('.')[1]));
        const user = {
          username: attrs['username'] || attrs['cognito:username'],
          name: attrs.name,
          cnpj: attrs['custom:cnpj'],
          isSpecialist: attrs['custom:isSpecialist'],
          shouldSignPrivacyTerm: attrs['custom:privacyTermSigned'] !== '1',
          isGeneralist: attrs['custom:isGeneralist'],
          isManager: attrs['custom:isManager'],
          isWhiteMartins: attrs['custom:isWhiteMartins'],
          canSeeAllCnpjs: attrs['custom:canSeeAllCnpjs'],
          isAdmin: attrs['custom:isAdmin'],
          patientV2Profile: attrs['custom:patientV2Profile'] || (attrs['custom:isAdmin'] === '1' ? 'avaliador_regulatorio' : 'solicitante'),
          token: ssoIdToken,
          refreshToken: '', //
          companyName: attrs['custom:companyName'],
          email: attrs.email,
          accessImplantacao: attrs['custom:accessImplantacao'],
          accessAssistencia: attrs['custom:accessAssistencia'],
          accessRecarga: attrs['custom:accessRecarga'],
          accessRecolhimento: attrs['custom:accessRecolhimento'],
          accessVenda: attrs['custom:accessVenda'],
          accessSubalocacao: attrs['custom:accessSubalocacao'],
          accessReport: attrs['custom:accessReport'],
          accessPremium: attrs['custom:accessPremium'],
          canEditPaymentList: attrs['custom:canEditPaymentList'],
          email_verified: attrs['email_verified'],
        };
        localStorage.setItem('portalHomeCareAuth', JSON.stringify(user));
        Cookies.set('token', token, {
          path: '/',
          secure: true,
          sameSite: 'None',
          expires: 1 / 24, // 1 hora
        });
        // Caso de usuario autenticar no cognito com sucesso recebe o id do token para recriar o token no front cognito via amplify
        Cookies.set('ssoIdToken', ssoIdToken, {
          path: '/',
          secure: true,
          sameSite: 'None',
          expires: 1 / 24, // 1 hora
        });
        // Caso de usuario autenticar no cognito recebeu o token da sessão para completar o desafio (desafio via SMS ate o momento)
        Cookies.set('ssoChallengeSession', ssoChallengeSession, {
          path: '/',
          secure: true,
          sameSite: 'None',
          expires: 1 / 24, // 1 hora
        });
        // Caso se usuario autenticar no cognito recebeu desafio pra fazer, identifica o tipo de dispositivo a verificar(SMS ate o momento)
        Cookies.set('ssoChallengeDevice', ssoChallengeDevice, {
          path: '/',
          secure: true,
          sameSite: 'None',
          expires: 1 / 24, // 1 hora
        });
        //
        Cookies.set('ssoUsername', ssoUsername, {
          path: '/',
          secure: true,
          sameSite: 'None',
          expires: 1 / 24, // 1 hora
        });
        //
        Cookies.set('authSource', authSource, {
          path: '/',
          secure: true,
          sameSite: 'None',
          expires: 1 / 24, // 1 hora
        });
        //
        if (user && user.shouldSignPrivacyTerm) {
          window.location.href = '/privacyTerm';
        } else {
          window.history.replaceState({}, document.title, '/orders');
          window.location.href = '/orders';
        }
      } catch (error) {
        console.log('OCORREU UM ERRO NO SSO', error);
        window.location.href = '/login';
      }
    } else {
      console.error('[SSO] Token ausente na URL de callback.');
      window.location.href = '/login';
    }
  }, []);

  return (
    <div style={{ textAlign: 'center', marginTop: '20vh' }}>
      <h2>Processando login seguro...</h2>
      <p>Por favor, aguarde...</p>
    </div>
  );
}
